'use strict';

import { appendQueryParams } from '../utils';

export default (API) => ({
    formsAH635: {
        getFormById: (formId, establishmentId) => {
            let url = `/v3/establishments/${establishmentId}/forms/${formId}`;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getTodayForms: (params) => {
            const { limit, currentPage, sortBy, descending, hideCompletedForms, hideCancelledAppointments } = params;
            let url = `/v3/forms/today?page=${currentPage}&limit=${limit}&sortBy=${sortBy}`;
            url = descending ? `${url}&descending=${descending}` : url;
            url = hideCompletedForms ? `${url}&hideCompletedForms=${hideCompletedForms}` : url;
            url = hideCancelledAppointments ? `${url}&hideCancelledAppointments=${hideCancelledAppointments}` : url;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getFormBySearch(params) {
            const { search, limit, currentPage, sortBy, descending, hideCompletedForms } = params;
            let url = `/v3/forms/search?value=${search}&page=${currentPage}&limit=${limit}&sortBy=${sortBy}`;
            url = descending ? `${url}&descending=${descending}` : url;
            url = hideCompletedForms ? `${url}&hideCompletedForms=${hideCompletedForms}` : url;
            const request = API.http.get(url);
            return API.handleError(request);
        },

        getFormByGlobalSearch(params) {
            let url = '/v3/forms/globalSearch';
            url = appendQueryParams(url, params);
            const request = API.http.get(url);
            return API.handleError(request);
        },

        updateForm: (formId, params) => {
            let url = `/v3/forms`;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },

        transmitForm: (params) => {
            let url = `/v3/forms/transmit`;
            const request = API.http.put(url, params);
            return API.handleError(request);
        },

        exportForm: (establishmentId, params) => {
            let url = `/v3/establishments/${establishmentId}/forms/export`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },

        batchExportForm: (establishmentId, params) => {
            let url = `/v3/establishments/${establishmentId}/forms/batchExport`;
            const request = API.http.post(url, params);
            return API.handleError(request);
        },
    },
});
